module.exports = __webpack_public_path__ + "img/ic_third_place.2a264f10.svg";